module.exports = __webpack_public_path__ + "static/media/lrmode.3e719249.png";